import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=f1a4cf8e&lang=pug&"
import script from "./SearchWidget.vue?vue&type=script&lang=js&"
export * from "./SearchWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports